require('./video-file.component.scss');

class VideoFileController {
  constructor(
    $scope,
  ) {
    this.$scope = $scope;
    this.$scope.onVideoStarted = () => this.$scope.$emit('videoStarted');
    this.$scope.onVideoEnded = () => this.$scope.$emit('videoEnded');
  }

}

export const VideoFileComponent = {
  template: require('./video-file.component.html'),
  controller: VideoFileController,
  bindings: {
    src: '<',
    thumb: '<',
    thumbClick: '&',
  },
};



// WEBPACK FOOTER //
// ./src/facts/video/video-file.component.js